<script setup>
import { ref, computed, watch } from 'vue'
import { gsap } from 'gsap'
const emit = defineEmits(['update:modelValue'])
const props = defineProps(['modelValue', 'filter', 'type', 'required', 'placeholder', 'disabled', 'max', 'label', 'icon', 'error', 'autocomplete', 'class', 'spellcheck', 'autocapitalize', 'rows', 'cols'])

const textarea = ref(null)

watch(
	() => props.error,
	(newVal, oldVal) => {
		if (newVal && newVal !== oldVal && textarea.value) {
			gsap.timeline().to(textarea.value, { x: -7, duration: 0.06, ease: 'power2.out' }).to(textarea.value, { x: 7, duration: 0.06, ease: 'power2.out' }).to(textarea.value, { x: -5, duration: 0.06, ease: 'power2.out' }).to(textarea.value, { x: 5, duration: 0.06, ease: 'power2.out' }).to(textarea.value, { x: -3, duration: 0.06, ease: 'power2.out' }).to(textarea.value, { x: 0, duration: 0.06, ease: 'power2.inOut' })
		}
	},
)
</script>

<template>
	<div class="flex w-full flex-col gap-1.5">
		<label class="text-sm text-crowns-off-white" v-if="label">
			{{ label }}
		</label>
		<div class="relative w-full">
			<textarea :type="type || 'text'" :class="[{ 'input-padding': icon }, 'input']" :placeholder="placeholder" :maxlength="max" :required="required" :value="modelValue" :autocomplete="autocomplete" :disabled="disabled" :spellcheck="spellcheck" :autocapitalize="autocapitalize" ref="textarea" :rows="rows" @input="emit('update:modelValue', $event.target.value)" />
		</div>
		<p class="text-xs text-red-500" v-if="error">
			{{ error }}
		</p>
	</div>
</template>

<style scoped>
textarea {
	@apply min-h-20 w-full grow border border-crowns-grey bg-crowns-dark-grey px-2 py-3 text-sm normal-case placeholder:normal-case placeholder:text-crowns-castle-stone focus:border-[#2c2c2c] focus:outline-none;
}
.icon-padding {
	@apply pl-10;
}
</style>
